module.exports = __webpack_public_path__ + "static/tooltip1_1-cc3a56520bdd9bd65f7a45852e81c857.png";